module.exports = __webpack_public_path__ + "static/vis-reg-diff-7ad079890e8723e03acded6d29ccb0bb.png";